import { useConfigureBoq } from "../contexts/ConfigureBoqContext";

/**
 * Whether the current user may add/edit sections and items across the
 * Dynamic Bill Summary tabs and every groundworks Bill Summary's ad-hoc
 * extra items.
 *
 * Currently backed by the runtime "Configure BOQ" switch next to the
 * Re-calculate button on /groundworks/review (see ConfigureBoqContext.tsx) —
 * any user can flip it themselves. This hook is the single seam every
 * consumer (all ten groundworks Bill Summary components, useDynamicBillSummary.tsx)
 * checks instead of reading `useConfigureBoq()` directly, so that swapping
 * the switch for a user-role permission check later (e.g. deriving this from
 * `useAuth().user.role` instead) only means changing this one function's
 * body — no consumer, and no other file, needs to change.
 */
export const useCanConfigureBoq = (): boolean => useConfigureBoq();
